import type { LandingExperienceData, LandingExperienceResponse } from './interfaces'

//TODO: will be removed in TM-1346 when integrated with API
export const MOCK_LANDING_EXPERIENCE_DATA: LandingExperienceData = {
  heading: 'Use Gousto your way',
  hero: {
    welcome: 'Welcome back, Customer',
    welcomeMobile: 'Welcome back!',
    headline: 'Good food, your way',
    subtitle:
      'Pick the rhythm that suits you.\nA one-off box when you fancy it, or regular deliveries you can skip anytime.',
  },
  banner: {
    title: 'Get 60% off your next box',
    subtitle: 'Applies to either option below',
  },
  options: [
    {
      id: 'one_off_box',
      title: 'Order a one-off box',
      summary: 'Subscription-free flexible ordering',
      tags: ['No commitment', 'Next day delivery available'],
      action: {
        intent: 'start_one_off_order',
        label: 'Order a box',
      },
    },
    {
      id: 'resubscribe',
      title: 'Resubscribe',
      summary: 'For guaranteed regular deliveries',
      tags: ['Skip anytime', 'Delivery slot guaranteed', 'Next day delivery available'],
      action: {
        intent: 'reactivate_subscription',
        label: 'Resubscribe',
      },
    },
  ],
  defer: {
    intent: 'defer_decision',
    label: "I'll decide later",
  },
}

export const MOCK_LANDING_EXPERIENCE_200_RESPONSE: LandingExperienceResponse = {
  status: 200,
  data: MOCK_LANDING_EXPERIENCE_DATA,
}

export const MOCK_LANDING_EXPERIENCE_204_RESPONSE: LandingExperienceResponse = {
  status: 204,
  data: null,
}
